import PhoneInput from "./FieldPhone";
import { withErrorMessage } from "../withErrorMessage";

export const FieldPhone = withErrorMessage(PhoneInput);

export default PhoneInput;
